export function testimonials () {
    function bty_testimonials() {
        let slider = document.body.querySelectorAll('.template-clients__testimonials-slide');
        let controller = document.body.querySelectorAll('.template-clients__controller-button');

        let i;
        for (i = 0; i < controller.length; i++) {
            let active = slider[i];
            controller[i].addEventListener('click', function () {
                controller.forEach(e => e.classList.remove('active'));
                slider.forEach(e => e.classList.remove('active'));
                active.classList.add('active');
                this.classList.add('active');
            });
        }
    }

    // window.onload = bty_rotateAdjuster;
    document.addEventListener('DOMContentLoaded', function () {
        bty_testimonials();
    });
};
